$( window ).on("load", function() {
 // alert("gg");
    if($(".globo-form-app .content.block-container .globo-form-control").length){

        $(".globo-form-app .content.block-container .globo-form-control").each(function(){
         // alert($(this).text());
            var get_form_obj = $(this);
            var get_form_label = $(this).find("label [data-label]").attr("data-label");
            if(get_form_label == "Point of sale city"){
                get_form_obj.find("input").val("Garden City");
                get_form_obj.addClass("disable_block");
            }
      
            if(get_form_label == "Point of sale address"){
                get_form_obj.find("input").val("840 Franklin Avenue");
                get_form_obj.addClass("disable_block");
            }    
      
            if(get_form_label == "Product Name"){
              var get_selected_product_name = $(".product-single__meta .product__title").text();
                //get_form_obj.find("input").val(get_selected_product_name);          
            }    
      
            if(get_form_label == "Your message"){  
              let get_contact_auto_message = $('.contact-form_message_reference').text();
                get_form_obj.find("textarea").val(get_contact_auto_message);          
            }        
          
        });   
      
    }     
});

$( window ).on("load", function() {
    if($(".globo-form-app .panel .globo-form-control").length){

      $("body").on('keyup change', '#52830-text', function(e) {
  
          var dInput_name = $(this).val();  
          $(this).val(capitalizeFirstLetter(dInput_name));
        $(".globo-form-app .panel .globo-form-control").each(function(){          
            var get_form_obj = $(this);
            var get_form_label = $(this).find("label [data-label]").attr("data-label");   
      
            if(get_form_label == "Email Name"){              
              
                get_form_obj.find("input").val(capitalizeFirstLetter(dInput_name));          
            }    
        });        
  
      });
      $("body").on('keyup change', '#52830-text-1', function(e) {
          var dInput_lname = $(this).val();  
          $(this).val(capitalizeFirstLetter(dInput_lname));       
      });
      

function capitalizeFirstLetter(val) {
    return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}      
      
        $(".globo-form-app .panel .globo-form-control").each(function(){
          //alert($(this).text());
            var get_form_obj = $(this);
            var get_form_label = $(this).find("label [data-label]").attr("data-label");
            if(get_form_label == "Point of sale city"){
                get_form_obj.find("input").val("Garden City");
                get_form_obj.addClass("disable_block");
            }
      
            if(get_form_label == "Point of sale address"){
                get_form_obj.find("input").val("840 Franklin Avenue");
                get_form_obj.addClass("disable_block");
            }    
      
            if(get_form_label == "Product Name"){
              var get_selected_product_name = $(".product-single__meta .product__title").text();
                //get_form_obj.find("input").val(get_selected_product_name);          
            }    
      
            if(get_form_label == "Your message"){  
              let get_contact_auto_message = $('.contact-form_message_reference').text();
                get_form_obj.find("textarea").val(get_contact_auto_message);          
            } 
          
            if(get_form_label == "Product Image"){  
              let get_contact_auto_product_image = $('.contact-form_product_image').html();
                get_form_obj.find("input").val(get_contact_auto_product_image);          
            }    

            if(get_form_label == "Product Info"){  
              let get_contact_auto_product_info = $('.contact-form_product_info').text();
                get_form_obj.find("input").val(get_contact_auto_product_info);          
            }      
            if(get_form_label == "Email Content"){  
              //alert("found");
              let get_contact_auto_product_email_content = $('.contact-form_product_email_content').text();
                get_form_obj.find("input").val(get_contact_auto_product_email_content);          
            }      

            if(get_form_label == "Email Before Image Content"){  
              let get_contact_auto_product_email_before_image_content = $('.contact-form_product_email_content_before_image').text();
                get_form_obj.find("input").val(get_contact_auto_product_email_before_image_content);          
            }                
      
        });   
      
    }     
});


// ROLEX V7 Contact Form
$( window ).on("load", function() {
    if($(".globo-form-app .panel.block-container .globo-form-control").length){

        $(".globo-form-app .panel.block-container .globo-form-control").each(function(){
          //alert($(this).text());
            var get_form_obj = $(this);
            var get_form_label = $(this).find("label [data-label]").attr("data-label");
            if(get_form_label == "Store City"){
                get_form_obj.find("input").val("Garden City");
                get_form_obj.addClass("disable_block");
            }
      
            if(get_form_label == "Store Address"){
                get_form_obj.find("input").val("840 Franklin Avenue");
                get_form_obj.addClass("disable_block");
            }                
        });   
      
    }     

  if($('#globo-formbuilder-52830').length){
          $("#globo-formbuilder-52830 .globo-form-app .globo-form-control").each(function(){            
              var get_form_obj = $(this);
              var get_form_label = $(this).find("label [data-label]").attr("data-label");           
              if(get_form_label == "Message"){
                  var get_product_name = $('.main-text-content h2.headline-50').attr('data-pro-title');
                  var get_product_ref_sku = $('.main-text-content h2.headline-50').attr('data-reference-sku');
                
                  get_form_obj.find("textarea").val("I'm interested in the Rolex "+get_product_name+", reference "+get_product_ref_sku);
                  get_form_obj.addClass("disable_block");
              }                    
          });   
  }

// RCPO NEW CONTACT FORM ON PRODUCT PAGE
    if($('#globo-formbuilder-72419').length){
          $("#globo-formbuilder-72419 .globo-form-app .globo-form-control").each(function(){            
              var get_form_obj = $(this);
              var get_form_label = $(this).find("label [data-label]").attr("data-label");           
              if(get_form_label == "Message"){
                  var get_product_name = $('.rcpo_main_text_content h2.headline-50').attr('data-pro-title');
                  var get_product_ref_sku = $('.rcpo_main_text_content h2.headline-50').attr('data-reference-sku');
                
                  get_form_obj.find("textarea").val("I'm interested in the Rolex "+get_product_name+", reference "+get_product_ref_sku);
                  get_form_obj.addClass("disable_block");
              }                    
          });   
  }
  
});



$(document).ready(function () {
		// Hide all about-watch-contents and remove active class
		$('.about-watch-accordion .about-watch-content').hide();
		$('.about-watch-accordion li').removeClass('active');

		// Show the first about-watch-content and add the active class to its parent
		$('.about-watch-accordion li:first-child .about-watch-content').show();
		$('.about-watch-accordion li:first-child').addClass('active');

		// about-watch-accordion functionality for clicking on titles
		$('.about-watch-accordion li').click(function () {
			var text = $(this).children('div.about-watch-content');

			// Close other about-watch-contents and remove their active class
			if (text.is(':hidden')) {
				$('div.about-watch-content').slideUp('400');
				$('.about-watch-accordion li').removeClass('active');

				// Open the clicked about-watch-content and add the active class to its parent
				text.slideDown('400');
				$(this).addClass('active');
			} else {
				text.slideUp('400');
				$(this).removeClass('active');
			}
		});
	});




// onclick info-icon
$(document).ready(function(){
$(".rolex_product__price.custom_al_code .info-circle").click(function(){
  $(".rolex_product__price.custom_al_code .info-circle").toggleClass("tooltip-top"); 
  $(".rolex_product__price.custom_al_code .Rolex-Price-info").toggleClass("show");
});
});

$(document).ready(function(){
$(".refund-policy .info-circle").click(function(){
  $(".refund-policy .info-circle").toggleClass("tooltip-top"); 
  $(".refund-policy .Rolex-Price-info").toggleClass("show");
});
});


$(document).ready(function(){
$(".price-info-circle").click(function(){
  $(".price-info-circle").toggleClass("tooltip-top"); 
  $(".Price-info-popup").toggleClass("show");
});
});	

       $('.v7-rolex-keep-exploring-grid').slick({
        slidesToShow: 4,
        slidesToScroll: 3,
        arrows: true,
        dots: true,
        infinite: false,
        autoplay: false,
        prevArrow: '<button class="slick-prev slick-arrow  slide-arrow prev-arrow"><svg class="undefined rtl css-1emgvlg e10fsun60" height="15" width="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true" alt="" style="width: 15px;"><path d="M11.7,7.5l-1.4,1.4l-5.7,5.7l-1.4-1.4l5.7-5.7L3.3,1.9l1.4-1.4l5.7,5.7l0,0L11.7,7.5z"></path></svg></button>',
        nextArrow: '<button class="slick-next slick-arrow slide-arrow next-arrow"><svg class="undefined rtl css-1emgvlg e10fsun60" height="15" width="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true" alt="" style="width: 12px;"><path d="M11.7,7.5l-1.4,1.4l-5.7,5.7l-1.4-1.4l5.7-5.7L3.3,1.9l1.4-1.4l5.7,5.7l0,0L11.7,7.5z"></path></svg></button>',
        responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        }        
      ]
    });

    $('.v2-rcpo-keep-exploring-grid').slick({
        slidesToShow: 4,
        slidesToScroll: 3,
        arrows: true,
        dots: true,
        infinite: false,
        autoplay: false,
        mobileFirst:true,
        prevArrow: '<button class="slick-prev slick-arrow  slide-arrow prev-arrow"><svg class="undefined rtl css-1emgvlg e10fsun60" height="15" width="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true" alt="" style="width: 15px;"><path d="M11.7,7.5l-1.4,1.4l-5.7,5.7l-1.4-1.4l5.7-5.7L3.3,1.9l1.4-1.4l5.7,5.7l0,0L11.7,7.5z"></path></svg></button>',
        nextArrow: '<button class="slick-next slick-arrow slide-arrow next-arrow"><svg class="undefined rtl css-1emgvlg e10fsun60" height="15" width="15" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true" alt="" style="width: 12px;"><path d="M11.7,7.5l-1.4,1.4l-5.7,5.7l-1.4-1.4l5.7-5.7L3.3,1.9l1.4-1.4l5.7,5.7l0,0L11.7,7.5z"></path></svg></button>',
        responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 3,
            mobileFirst:true
          }
        },{
          breakpoint: 0,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            mobileFirst:true
          }
        }          
      ]
    });

     
      $('.rolex-keep-exploring-grid').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: false,
        autoplay: false,
        prevArrow: '<button class="slick-prev slick-arrow  slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225   c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
        nextArrow: '<button class="slick-next slick-arrow slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5   c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z   "/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
        responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          }
        }        
      ]
    });


    $('.tudor-ambassadors-lists').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        dots: false,
        infinite: false,
        autoplay: false,
        prevArrow: '<button class="slick-prev slick-arrow  slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225   c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
        nextArrow: '<button class="slick-next slick-arrow slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5   c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z   "/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
        responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1,
          }
        } 
      ]
    });

    $('.about-tudor-lists').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        autoplay: false,
        prevArrow: '<button class="slick-prev slick-arrow  slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225   c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
        nextArrow: '<button class="slick-next slick-arrow slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5   c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z   "/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
        responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1.2,
          }
        } 
      ]
    });    


    /*
      START: Rolex Product Page Script
    */
       // Media slider
       $('.product-main-media__Rolex').slick({
         slidesToShow: 1,
         slidesToScroll: 1,
          arrows: true,
           dots: true,
          fade: true,
         infinite: false,
         prevArrow: '<button class="slick-prev slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225   c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
         nextArrow: '<button class="slick-next slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5   c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z   "/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
         responsive: [
          {
            breakpoint: 1068,
            settings: {
               slidesToShow: 1,
              slidesToScroll: 1,
                arrows: false,
                dots: true
            }
          }
        ]
        
       });
     
       $('.product-thumbnails-slider__Rolexh').slick({
          slidesToShow: 4,
         slidesToScroll: 1,
          asNavFor: '.product-main-media__Rolex',
          dots: false,
          focusOnSelect: true,
           adaptiveHeight: true,
           arrows: false,
           infinite: false
       });

     $('a[data-slide]').click(function(e) {
       e.preventDefault();
       var slideno = $(this).data('slide');
       $('.product-main-media__Rolex').slick("resize");
       $('.product-main-media__Rolex').slick('slickGoTo', slideno - 1);
     });

      
      $("body").on("click", '.product-thumbnails-slider__Rolex a.product-single__thumbnail', function() {
          $('body').addClass('activeRolexGalleryBlock');
      });
      $("body").on("click", '.rolex_gallery_close_btn', function() {
          $('body').removeClass('activeRolexGalleryBlock');
      });     

     
    /*
      END: Rolex Product Page Script
    */

$(document).ready(function(){
    $('#social-sharing__icon_show_btn').click(function() {
      $('.social-sharing__icon').toggle("slide");
    });
});

$(document).ready(function(){
  $(".trigger_wishlist_icon").click(function(){
    $(".swym-button").trigger("click");
  });
});

    $(".menu-trigger .mm_title").click(function(){
      $(".mobile-menu-element").slideToggle(300);
      $(".menu-trigger").toggleClass("is-expanded");
    });




    var btn = $('#rolex_backToTop');
    btn.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '500');
    });



    $('.rolex-related_products').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        arrows: true,
        dots: true,
        infinite: false,
        autoplay: false,
        prevArrow: '<button class="slick-prev slick-arrow  slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225   c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
        nextArrow: '<button class="slick-next slick-arrow slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5   c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z   "/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
        responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        }        
      ]
    });


$('.rcpo-featured-collection').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        infinite: false,
        autoplay: false,
        prevArrow: '<button class="slick-prev slick-arrow  slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225   c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
        nextArrow: '<button class="slick-next slick-arrow slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5   c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z   "/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
        responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        }        
      ]
    });

  // Add smooth scrolling to all links
  $("a.smoothscroll").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){

        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
  });


     //Contact Page
$("button.opening-hours").click(function(){
  $("ul.opening-hours-list").toggleClass("js_open");
});
     


// Rolex pre-owned page

      $('.rolex-pre-owned-grid').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: false,
        autoplay: false,
        prevArrow: '<button class="slick-prev slick-arrow  slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225   c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
        nextArrow: '<button class="slick-next slick-arrow slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5   c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z   "/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
        responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
          }
        } 
      ]
    });


      $('.tudor-ambassadors-lists').slick({
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        dots: false,
        infinite: false,
        autoplay: false,
        prevArrow: '<button class="slick-prev slick-arrow  slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225   c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
        nextArrow: '<button class="slick-next slick-arrow slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5   c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z   "/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
        responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1.2,
            slidesToScroll: 1,
          }
        } 
      ]
    });


      $('.about-tudor-lists').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        autoplay: false,
        prevArrow: '<button class="slick-prev slick-arrow  slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M145.188,238.575l215.5-215.5c5.3-5.3,5.3-13.8,0-19.1s-13.8-5.3-19.1,0l-225.1,225.1c-5.3,5.3-5.3,13.8,0,19.1l225.1,225   c2.6,2.6,6.1,4,9.5,4s6.9-1.3,9.5-4c5.3-5.3,5.3-13.8,0-19.1L145.188,238.575z"/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
        nextArrow: '<button class="slick-next slick-arrow slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" width="25px" height="25px" x="0px" y="0px" viewBox="0 0 477.175 477.175" style="enable-background:new 0 0 477.175 477.175;" xml:space="preserve"> <g> <path d="M360.731,229.075l-225.1-225.1c-5.3-5.3-13.8-5.3-19.1,0s-5.3,13.8,0,19.1l215.5,215.5l-215.5,215.5   c-5.3,5.3-5.3,13.8,0,19.1c2.6,2.6,6.1,4,9.5,4c3.4,0,6.9-1.3,9.5-4l225.1-225.1C365.931,242.875,365.931,234.275,360.731,229.075z   "/> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> <g> </g> </svg></button>',
        responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1.2,
          }
        } 
      ]
    });


/* ----- Page: rolex-certified-preowned-contact ------ */

if($(".day-opening-hours").length){
    const get_rolex_d = new Date();
    let get_rolex_day = get_rolex_d.getDay();        
  //alert(get_rolex_day);
  if(get_rolex_day == 1 || get_rolex_day == 0){
      get_rolex_day = 'Closed';
      $(".opening-hours").find("[data-day='" + get_rolex_day + "'].day-opening-hours").css("display","inline-block"); 
      $("#opening-hours-list").find("[data-day='" + get_rolex_day + "'].hrs").addClass("active_day");               
  }else{
      $(".opening-hours").find("[data-day='" + get_rolex_day + "'].day-opening-hours").css("display","inline-block"); 
      $("#opening-hours-list").find("[data-day='" + get_rolex_day + "'].hrs").addClass("active_day");               
  }

}